<template>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55" />-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
            >
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {doQueryPathVehicleAlarm} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: '',
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'pathName', label: '路径名称'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'startTime', label: '偏移开始时间'},
          {prop: 'endTime', label: '偏移结束时间'},
          {prop: 'startAddress', label: '偏移开始地点'},
          {prop: 'endAddress', label: '偏移结束地点'},
          {prop: 'deviationTime', label: '偏移时长(秒)'},
          {prop: 'deviationMileage', label: '偏移总里程（公里）'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryPathVehicleAlarm,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
